import { Dialog } from '@radix-ui/themes';

export default Dialog;
